import React from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "../contexts/UserContext";
import { Box, Spinner, Center, Text } from "@chakra-ui/react";
import { tt } from "../i18n/tt";

const PPLProtectedRoute = ({ children, requireKT = false, requireAdmin = false }) => {
  const { userInfo, isLoading } = useUser();

  if (isLoading) {
    return (
      <Center h="100vh">
        <Box textAlign="center">
          <Spinner size="xl" color="brand.500" thickness="4px" />
          <Text mt={4} color="gray.600">
            {tt("a.06057fa4", "로딩 중...")}
          </Text>
        </Box>
      </Center>
    );
  }

  // 로그인 확인
  if (!userInfo.email) {
    return <Navigate to="/login" replace />;
  }

  // KT 계정 필요
  if (requireKT && userInfo.company !== "KT") {
    return (
      <Center h="100vh">
        <Box textAlign="center">
          <Text fontSize="xl" fontWeight="bold" color="red.500" mb={2}>
            {tt("a.37d07591", "접근 권한이 없습니다")}
          </Text>
          <Text color="gray.600">{tt("a.66871c58", "콘텐츠 기업(KT) 계정만 이용할 수 있습니다.")}</Text>
        </Box>
      </Center>
    );
  }

  // 관리자 권한 필요
  if (requireAdmin && !userInfo.role.includes("Admin")) {
    return (
      <Center h="100vh">
        <Box textAlign="center">
          <Text fontSize="xl" fontWeight="bold" color="red.500" mb={2}>
            {tt("a.37d07591", "접근 권한이 없습니다")}
          </Text>
          <Text color="gray.600">{tt("a.184543ac", "운영팀 권한이 필요합니다.")}</Text>
        </Box>
      </Center>
    );
  }

  return children;
};

export default PPLProtectedRoute;

